module.exports = __webpack_public_path__ + "static/img/1.fef280d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carouseImg/1.png
// module id = Rs7n
// module chunks = 0